import React from 'react';
import {FormControl, InputGroup} from "react-bootstrap";

function TextInput(props) {
    return (
        <div className="custom-input">
            <InputGroup>
                <div className="icon">
                    {props.children}
                </div>
                <FormControl
                             type={props.type}
                             size={props.size}
                             name={props.name}
                             placeholder={props.placeholder}
                             onChange={props.onChange}
                             onBlur={props.onBlur}
                />

            </InputGroup>
        </div>
    );
}

export default TextInput;
